module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "setSort"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "700",
      "title": "列表设置",
      "before-close": _vm.closeDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "sort-box"
  }, [(_vm.moduleName !== 'productStock') ? _c('div', {
    staticClass: "sort-item"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("默认排序规则")]), _vm._v(" "), _c('div', {
    staticClass: "sort-set"
  }, [_c('span', [_vm._v("默认按照")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        _vm.sortSet = 1
      }
    },
    model: {
      value: (_vm.sortOptin),
      callback: function($$v) {
        _vm.sortOptin = $$v
      },
      expression: "sortOptin"
    }
  }, _vm._l((_vm.sortArray), function(item) {
    return _c('el-option', {
      key: item.attr,
      attrs: {
        "label": item.attrName,
        "value": item.attr
      }
    })
  })), _vm._v(" "), _c('el-select', {
    staticClass: "sort-select",
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.sortSet),
      callback: function($$v) {
        _vm.sortSet = $$v
      },
      expression: "sortSet"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "升序",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "降序",
      "value": -1
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sort-item"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("列表显示字段")]), _vm._v(" "), _c('div', {
    staticClass: "filter"
  }, [_c('el-table', {
    ref: "filterTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.initValue,
      "max-height": "250",
      "row-key": "alias"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "字段名称",
      "width": "120",
      "prop": "attrName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label-class-name": "label-class-name",
      "type": "selection"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cb890f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/set-sort.vue
// module id = 1266
// module chunks = 82